<template>
    <div class="parking-lot-status">
        <v-checkbox
            v-if="params.data.isInParkingLot || params.isPastPromotions"
            v-model="value"
            @change="setSelected"
        />
        <v-checkbox v-if="params.value === parkingLotStates.planned" v-model="value" disabled />
        <icon v-if="params.value === parkingLotStates.executed" icon-name="locked" small />
    </div>
</template>

<script>
import Vue from 'vue';
import parkingLotStates from '@enums/parking-lot-states';

export default Vue.extend({
    data() {
        return {
            parkingLotStates,
            value: true,
        };
    },
    events: {
        onSelectAllChanged(param) {
            if (this.params.value === parkingLotStates.planned) return;
            this.selectAllHandler(param);
        },
    },
    mounted() {
        if (this.params.value === parkingLotStates.planned) {
            this.value = true;
            return;
        }
        this.value = this.params.node.isSelected();
    },
    methods: {
        setSelected(value) {
            this.params.node.setSelected(value);
        },
        selectAllHandler(param) {
            this.params.node.setSelected(param);
            this.value = this.params.node.isSelected();
        },
    },
});
</script>

<style lang="scss" scoped>
.parking-lot-status {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    // Removes the default margin-right: 8px on v-checkbox
    ::v-deep .rtls-checkbox * {
        margin-right: 0px;
    }

    ::v-deep {
        .v-input--selection-controls {
            margin-top: 0;
        }
        .v-input--selection-controls__input {
            margin-right: 0 !important;
        }

        .v-icon.v-icon {
            font-size: 2rem;
        }
    }
}
</style>
